<template>
    <b-card>
        <b-tabs card>
            <b-tab
                v-if="$can('view-intern-logs') || $can('view-report-logs') || $can('view-candidate-logs')"
                :title="uLang('app.log')"
            >
                <logs-tab entityType="relations" :entityId="relation.id" :showOnly="showOnly"/>
            </b-tab>

            <b-tab
                v-if="relation.type.system_name === 'candidate' && $can('view-trajectory-enrolments')"
                :title="uLang('app.trajectories')"
            >
                <slot name="trajectory-enrolments">
                    <div v-if="$can('enrol-candidates-in-trajectories')" class="clearfix m-3">
                        <router-link
                            class="btn btn-brand pull-right"
                            :to="{
                                name: 'admin.relations.trajectory-enrolments.create',
                                params: { relationId: relation.id },
                            }"
                        >
                            {{ uLang('app.enrol_candidate_to_trajectory') }}
                        </router-link>
                    </div>
                    <trajectory-enrolment-table
                        :url="route('relations.trajectory-enrolments.table', { relation: relation.id, })"/>
                </slot>
            </b-tab>

            <b-tab v-if="relationIsCandidate" :title="uLang('app.completed_report')">
                <all-reports-tab :entityId="relation.id"></all-reports-tab>
            </b-tab>

            <b-tab v-if="!$hasType('candidate') && $can('index-files')" :title="uLang('app.documents')">
                <documents-tab entityType="relations" :entityId="relation.id" :showOnly="showOnly"/>
            </b-tab>

            <b-tab v-if="relationIsCandidate" :title="uLang('app.application_activities')">
                <application-activities-tab entityType="relations" :entityId="relation.id" :showOnly="showOnly"/>
            </b-tab>

            <b-tab v-if="relation.type.system_name === 'coach'" :title="uLang('app.credits')">
                <coach-credit-tab resource="relations" :resource-id="relation.id" ref="coachCreditTab"
                                  :showOnly="showOnly"/>
            </b-tab>

            <b-tab v-if="relation.type.system_name === 'coach'" :title="uLang('app.website_info')">
                <website-info-tab :coach="relation" ref="coachWebsiteInfoTab"/>
            </b-tab>
        </b-tabs>
    </b-card>
</template>

<script>
    import {
        DocumentsTab,
        LogsTab,
        ApplicationActivitiesTab
    } from "~/components/tabs";
    import TrajectoryEnrolmentTable from "~/components/tables/admin/relation/trajectory-enrolment/table";
    import AllTrajects from "~/components/cards/dashboard/candidate/all-trajects";
    import LocationsTab from "./locations-tab"
    import CoachCreditTab from "./coach-credit-tab"
    import WebsiteInfoTab from "./website-info-tab"

    import AllReportsTab from "./all-reports-tab";

    export default {
        name: "UserTabs",
        components: {
            WebsiteInfoTab,
            CoachCreditTab,
            LocationsTab,
            LogsTab,
            ApplicationActivitiesTab,
            DocumentsTab,
            TrajectoryEnrolmentTable,
            AllTrajects,
            AllReportsTab,
        },
        props: {
            relation: {
                type: Object,
                required: true,
            },
            showOnly: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            relationIsCandidate() {
                return this.relation.type.system_name === 'candidate'
            }
        },
    };
</script>

<style></style>
